module.exports = __webpack_public_path__ + "static/media/8OLA29.f5e32c6e.jpg";